"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ReviewStar = /** @class */ (function (_super) {
    __extends(ReviewStar, _super);
    function ReviewStar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.starRatingClass = function (num) {
            if (num === 0) {
                return 's0-0';
            }
            var rating = Math.round(num * 2) / 2;
            return 's' + rating.toFixed(1).replace('.', '-');
        };
        // TODO: サイズも props で渡せたら使いやすいかもしれないけど、とりあえずは1箇所しか使ってないので xs 固定で
        _this.render = function () {
            var reviewStarClasses = "review__stars xs ".concat(_this.starRatingClass(_this.props.rate));
            return (react_1.default.createElement("span", { className: "review_rate_wrapper" },
                react_1.default.createElement("span", { className: reviewStarClasses }),
                _this.props.breakLine && react_1.default.createElement("br", null),
                _this.props.showRateNumber &&
                    react_1.default.createElement("span", { className: "review_rate_number" }, _this.props.rate)));
        };
        return _this;
    }
    ReviewStar.defaultProps = {
        rate: 0,
        breakLine: false,
        showRateNumber: true
    };
    return ReviewStar;
}(react_1.Component));
exports.default = ReviewStar;
